<template>
  <dv-active-ring-chart :key="refreshFlagKey" :config="config" style="width:100%;height:100%;"
    class="diy-active-ring-chart" ref="ring_chart" />
</template>

<script>
import { getDataJson, pollingRefresh,hasNonEmptyValues,hasProperty } from "@/utils/refresh-cpt-data";

export default {
  name: "cpt-dataV-activeRing",
  props: {
    width: Number,
    height: Number,
    option: Object,
    current: Object,
  components:Array
  },
  watch: {
    // 'option.attribute': {
    //   handler() {
    //     this.processData(this.option.cptDataForm,this.newData,this.jsFunFlag)
    //     // this.loadData(this.option.cptDataForm);
    //   },
    //   deep: true//深度监听
    // },
    width() {
      this.refreshFlagKey = require('uuid').v1();
    },
    height() {
      this.refreshFlagKey = require('uuid').v1();
    }
  },
  data() {
    return {
      uuid: null,
      config: {
        digitalFlopStyle: {}
      },
      refreshFlagKey: null,
      newData:'',
      jsFunFlag:false,
    }
  },
  created() {
    this.uuid = require('uuid').v1();

    this.refreshCptData(this.option.cptDataForm);
  },
  methods: {
    refreshCptData(cptDataForm) {
      pollingRefresh(this.uuid, cptDataForm, () => { this.loadData(cptDataForm) },
        this.components)
      this.refreshFlagKey = require('uuid').v1();
    },
    loadData(cptDataForm) {
      getDataJson(cptDataForm,'',(res)=> {
        console.log(this.option.attribute)
        this.newData = cptDataForm.dataSource == '4' && hasProperty(res,'jsFunction') ? res.resStr : res;//相同数据集只调用一次接口原因
        this.jsFunFlag = cptDataForm.dataSource == '4' && hasProperty(res,'jsFunction') ? res.jsFunction : false;//相同数据集只调用一次接口原因
        this.processData(cptDataForm,this.newData,this.jsFunFlag)

      })
    },
    processData(cptDataForm,res,jsFunFlag,isFromGrid){
          // 第一层判断 如果选择数据集
          if(cptDataForm.dataSource == '4') {
                if(this.current.cptOption.interaction.fatherGridId && isFromGrid != 'ninegrid')return 

            // 第二层判断 ，如果没有配转换脚本
            if(jsFunFlag) { // 没有全部配置映射字段
                //判断此控件在九宫格里面就不请求数据
                if(hasNonEmptyValues(this.option.attribute.cptTableData)) {
                    const dataKey = this.option.attribute.cptTableData;
                     let newarr = [];
                      // 遍历原始数组并重组数据
                        res.forEach(item => {
                          let name = item[dataKey[0].value];
                          let valueString = item[dataKey[1].value];
                          let value = Number(valueString); // 尝试将字段转换为数字类型
                          // 创建新的对象并添加到 aa 数组中
                          newarr.push({ name, value });
                        });
                        console.log(newarr,'新数组')
                        this.cptData = newarr; 
              }
             } else { // 如果配置了转换脚本
                this.cptData = res;
             }
          } else { // 不是数据集类型，是静态数据
               this.cptData = res;
          } 
           this.config = JSON.parse(JSON.stringify(this.option.attribute))
        this.config.data = this.cptData;
        if (this.option.attribute.fontColor) {
          this.config.digitalFlopStyle = {
            fill: this.option.attribute.fontColor
          }
        }
        this.$nextTick(() => {
          this.setStyle()
        })
  },
    setStyle() {
      let ring_chart = this.$refs.ring_chart?.$el

      if(!ring_chart) {
        return 
      }
      let div = Array.from(ring_chart?.children)?.find(x => x.className.includes('active-ring-info'))

      let textDiv = Array.from(div.children)?.find(x => x.className.includes('active-ring-name'))

      textDiv.style.color = this.option.attribute.fontColor
    } 
  }
}
</script>

<style>
.dv-active-ring-chart .active-ring-info .active-ring-name {
  /* color: #fff; */
}
</style>
